import { BaseFormHelperText } from '../BaseFormHelperText/BaseFormHelperText';
import { ErrorMessageProps } from './ErrorMessage.types';
import css from './ErrorMessage.module.scss';

/**
 * The error message that displays under certain controls.
 *
 * @note This error message does not use `Formik` context and
 * requires that the component using it passes  the `error` boolean as prop.
 *
 * @param classes - {@link ErrorMessageProps.classes classes} description.
 * @param wrapperClassName - {@link ErrorMessageProps.wrapperClassName wrapperClassName} description.
 * @param error - {@link ErrorMessageProps.error error} description. (default: `false`)
 * @param children - {@link ErrorMessageProps.children children} description.
 */
const ErrorMessage = ({
    classes,
    wrapperClassName,
    error = false,
    children,
}: ErrorMessageProps) => {
    return (
        error && children ? (
            <div role={'presentation'} className={wrapperClassName ? wrapperClassName : css.errorWrapper}>
                <BaseFormHelperText
                    classes={{
                        ...classes,
                        root: css.errorMessage,
                    }}
                >
                    {children}
                </BaseFormHelperText>
            </div>
        ) : null
    );
};

export default ErrorMessage;